import React from "react";
import Header from "../components/Header";
import "./Events.css";

const SkeletonBlock = ({ className = "" }) => (
  <span className={`event-skeleton ${className}`.trim()} aria-hidden="true" />
);

export const EventsListPageSkeleton = () => (
  <>
    <Header />
    <main className="events-shell" aria-busy="true" aria-label="Loading events">
      <span className="event-loading-label">Loading events</span>
      <div className="events-container">
        <div className="events-header">
          <div className="events-skeleton-copy">
            <SkeletonBlock className="events-skeleton-title" />
            <SkeletonBlock className="events-skeleton-description" />
          </div>
          <SkeletonBlock className="events-skeleton-button" />
        </div>

        <div className="events-grid">
          {Array.from({ length: 6 }, (_, index) => (
            <section className="events-skeleton-card" key={index}>
              <SkeletonBlock className="events-skeleton-card-preview" />
              <div className="events-skeleton-card-content">
                <SkeletonBlock className="events-skeleton-card-title" />
                <SkeletonBlock className="events-skeleton-card-meta" />
                <div className="events-skeleton-card-details">
                  <SkeletonBlock className="events-skeleton-card-chip" />
                  <SkeletonBlock className="events-skeleton-card-chip events-skeleton-card-chip-wide" />
                </div>
              </div>
            </section>
          ))}
        </div>
      </div>
    </main>
  </>
);

export const EventEditorPageSkeleton = ({ headerProps = {} }) => (
  <>
    <Header {...headerProps} />
    <main
      className="event-editor-loading-shell"
      aria-busy="true"
      aria-label="Loading badge editor"
    >
      <span className="event-loading-label">Loading badge editor</span>
      <section className="event-editor-loading-widget">
        <span className="event-editor-loading-spinner" aria-hidden="true" />
      </section>
    </main>
  </>
);
